// extracted by mini-css-extract-plugin
module.exports = {"row":"CardsRow_row__10FX3","editableRow":"CardsRow_editableRow__2ezAF"};